import type { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { Dot, HaloDot, Wrapper, type IndicatorDotProps } from './styles';
export { IndicatorDotVariants } from './styles';

export function IndicatorDotWrapper({
  children,
  size,
  placement = 'top-right',
  inset,
  ...props
}: Omit<IndicatorDotProps, 'halo'> & { placement?: 'top-right' | 'top-left'; children: ReactNode }) {
  const defaultTheme = useTheme();
  const theme = props.theme ?? defaultTheme;
  const { indicatorDotSizeDefault } = theme;
  size = size ?? indicatorDotSizeDefault;
  return (
    <Wrapper size={size} theme={theme} placement={placement} inset={inset}>
      {children}
      <IndicatorDot size={size} {...props} />
    </Wrapper>
  );
}

export function IndicatorDot({ halo, size, ...props }: IndicatorDotProps) {
  const defaultTheme = useTheme();
  const theme = props.theme ?? defaultTheme;
  const { indicatorDotSizeDefault } = theme;
  size = size ?? indicatorDotSizeDefault;

  if (halo) {
    return <HaloDot {...props} size={size} theme={theme} data-testid="indicator-dot" />;
  }
  return <Dot {...props} size={size} theme={theme} data-testid="indicator-dot" />;
}
